
const SETTINGS = {
  siteHomeUrl: process.env.VUE_APP_SITE_HOME_URL,
  apiUrl: process.env.VUE_APP_API_URL,
  logoutRedirect: process.env.VUE_APP_LOGOUT_REDIRECT,
  nonce: undefined,
  hereApiKey: '2ElMDh6bD2WUgQp6eNrXGHW9WzwZ3NIg5rtizm9gINg',
  // This is 100% for testing purposes only.
  //    (may need to create a test_user first)
  // authToken: 'paste contents from `$ python manage.py drf_create_token <test_user>`'
  authToken: process.env.VUE_APP_LOCAL_AUTH_TOKEN,
  accessToken: undefined,
  apiVersion: (process.env.VUE_APP_USE_API_V2) ? 'v2' : 'v3',
}

function _defaultPrepareHeaders() {
  var headers = {}

  if (SETTINGS.accessToken) {
    headers['Authorization'] = `Bearer ${SETTINGS.accessToken}`
  }
  else if (SETTINGS.nonce) {
    headers['X-WP-Nonce'] = SETTINGS.nonce
  } else {
    headers['Authorization'] = `Token ${SETTINGS.authToken}`
  }
  return headers
}

const _vars = {
  apiSet: false,
  callbacks: [],
  useAuth0: undefined,
  setAuthHeaders: _defaultPrepareHeaders,
  setAuthHeadersOverride: undefined,
}

function setApiData(siteHomeUrl, apiUrl, nonce, hereApiKey, apiVersion) {
  if (siteHomeUrl) SETTINGS.siteHomeUrl = siteHomeUrl
  if (apiUrl)      SETTINGS.apiUrl = apiUrl
  if (nonce)       SETTINGS.nonce = nonce
  if (hereApiKey)  SETTINGS.hereApiKey = hereApiKey
  if (apiVersion)  SETTINGS.apiVersion = apiVersion

  configureApiAuthVersion()

  console.log(SETTINGS)
  _vars.apiSet = true
  for (const cb of _vars.callbacks) {
    cb()
  }
  _vars.callbacks.length = 0
}

async function prepareHeaders() {
  if (_vars.setAuthHeadersOverride) {
    return await _vars.setAuthHeadersOverride()
  }
  else if (_vars.setAuthHeaders) {
    return await _vars.setAuthHeaders()
  }
  else {
    return await _defaultPrepareHeaders()
  }
}

function configureApiAuthVersion() {
  if (SETTINGS.apiVersion === 'v2' && SETTINGS.nonce) {
    _vars.setAuthHeaders = function wordpressApiAuthHeaders() {
      return {
        'X-WP-Nonce': SETTINGS.nonce,
      }
    }
    _vars.useAuth0 = false
  }
  else if (SETTINGS.apiVersion === 'v2' && !SETTINGS.nonce && SETTINGS.authToken) {
    _vars.setAuthHeaders = function djangoTokenApiAuthHeaders() {
      return {
        'Authorization': `Token ${SETTINGS.authToken}`,
      }
    }
    _vars.useAuth0 = false
  }
  else if (SETTINGS.apiVersion === 'v3' && !SETTINGS.nonce) {
    _vars.setAuthHeaders = function auth0DjangoJwtApiAuthHeaders() {
      return {
        'Authorization': `Bearer ${SETTINGS.accessToken}`,
      }
    }
    _vars.useAuth0 = true
  }
  else {
    _vars.useAuth0 = false
    console.error('Invalid API settings')
    console.error(`   Version: ${SETTINGS.apiVersion}, nonce set: ${Boolean(SETTINGS.nonce)}, auth token set: ${Boolean(SETTINGS.authToken)}`)
  }
}

function setAccessToken(accessToken) {
  if (accessToken) SETTINGS.accessToken = accessToken
}

function setAuthHeadersCallback(callback) {
  _vars.setAuthHeadersOverride = callback
}

function onApiConfigSet(callback) {
  _vars.callbacks.push(callback)
}

function useAuth0() {
  if (_vars.useAuth0 === undefined) {
    configureApiAuthVersion()
  }
  return _vars.useAuth0
}

function getApiVersion() {
  return `api/${SETTINGS.apiVersion}`
}

export {
  SETTINGS,
  setApiData,
  setAccessToken,
  setAuthHeadersCallback,
  onApiConfigSet,
  prepareHeaders,
  useAuth0,
  getApiVersion,
}
